var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"pageLoader"},[_c('loading-progress',{attrs:{"indeterminate":"","hide-background":"","size":"64","rotate":"","fillDuration":"2","rotationDuration":"1"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }